import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import {
  MeasuredInjectedProps,
  MeasuredContainer,
  MeasuredCookieType,
} from '@wix/da-shared-react/pkg/Measured';
import Thumb from './Thumb';

import s from './FeaturedDeviation.scss';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';

const MIN_CARD_WIDTH = 300;
const MIN_CARD_HEIGHT = 360;
const MAX_CARD_HEIGHT = 800;

export interface Props {
  isOwner: boolean;
  className?: string;
  title?: string;
  deviation?: PapiDeviation;
  showConfigMenu?: boolean;
}

const FeaturedDeviation: React.SFC<Props> = ({ className, deviation }) => (
  <MeasuredContainer
    cookieType={MeasuredCookieType.FEATURED_DEVIATION}
    cookieDim="width"
    listenOnWindow
  >
    {(measuredProps: MeasuredInjectedProps) => {
      const { width, height } = calculateBounds(
        (measuredProps.container && measuredProps.container.width) || 1000,
        deviation!
      );

      return (
        <div
          className={classnames(s['root'], className)}
          ref={measuredProps.onRef}
        >
          {deviation && (
            <Thumb deviation={deviation} width={width} height={height} />
          )}
        </div>
      );
    }}
  </MeasuredContainer>
);

function calculateBounds(containerWidth: number, deviation: PapiDeviation) {
  const type = getDeviationType(deviation);
  const preview = MediaService.getDeviationFile(deviation, 'preview');
  if (
    !preview ||
    type === DeviationTypes.JOURNAL ||
    type === DeviationTypes.LITERATURE
  ) {
    return {
      width: Math.max(containerWidth, MIN_CARD_WIDTH),
      height: MIN_CARD_HEIGHT,
    };
  }

  const { width: preWidth, height: preHeight } = preview;

  // Fit to width
  const widthRatio = containerWidth / (preWidth || 0);
  let height = Math.floor((preHeight || 0) * widthRatio);
  height = Math.min(height, MAX_CARD_HEIGHT);

  return {
    width: Math.max(containerWidth, MIN_CARD_WIDTH),
    height: Math.min(preHeight || height, Math.max(height, MIN_CARD_HEIGHT)),
  };
}

FeaturedDeviation.displayName = 'FeaturedDeviation';

export default FeaturedDeviation;
